import CamplaCoreService from "../services/CamplaCoreService";

class SecurityLevel {
  static getTranslationByStatus(status) {
    return SecurityLevel.levels.get(status + "");
  }

  static getSecurityLevels(instanceTemplateType) {
    const user = CamplaCoreService.getAuthenticatedUser();
    let securityLevels = [];

    // Add lernstick security options
    SecurityLevel.selectLevels
      .filter((i) => i.value === 2 || i.value === 1)
      .forEach((i) => securityLevels.push(i));

    // Add remote attestation options if remote attestation is enabled
    if (
      user.configuration &&
      user.configuration.services.camplaSentinel.enableRemoteAttestation
    ) {
      SecurityLevel.selectLevels
        .filter((i) => i.value === 4 || i.value === 3)
        .forEach((i) => securityLevels.push(i));
    }

    if (
      user.configuration &&
      user.configuration.services.safeExamBrowser.enable
    ) {
      // Allow VM-SEB examination if guacamole is enabled
      if (
        user.configuration &&
        instanceTemplateType === 0 &&
        user.configuration.services.guacamole.enable
      ) {
        SecurityLevel.selectLevels
          .filter((i) => i.value === 5 || i.value === 6)
          .forEach((i) => securityLevels.push(i));
        // Allow Web-SEB examination
      } else if (user.configuration && instanceTemplateType === 1) {
        SecurityLevel.selectLevels
          .filter((i) => i.value === 5 || i.value === 6)
          .forEach((i) => securityLevels.push(i));
      } else if (instanceTemplateType === undefined) {
        SecurityLevel.selectLevels
          .filter((i) => i.value === 5 || i.value === 6)
          .forEach((i) => securityLevels.push(i));
      }
    }

    SecurityLevel.selectLevels
      .filter((i) => i.value === 0)
      .forEach((i) => securityLevels.push(i));
    return securityLevels;
  }
}

SecurityLevel.levelObject = {
  2: "SecurityLevels.OptionPINCode",
  1: "SecurityLevels.OptionNoPINCode",
  4: "SecurityLevels.OptionRAPINCode",
  3: "SecurityLevels.OptionRANoPINCode",
  5: "SecurityLevels.OptionSEBNoPINCode",
  6: "SecurityLevels.OptionSEBPINCode",
  0: "SecurityLevels.OptionNoIsolation",
};

SecurityLevel.levels = new Map();
SecurityLevel.selectLevels = [];
for (const i in SecurityLevel.levelObject) {
  SecurityLevel.selectLevels.push({
    value: parseInt(i),
    label: SecurityLevel.levelObject[i],
  });
  SecurityLevel.levels.set(i + "", SecurityLevel.levelObject[i]);
}

export default SecurityLevel;
